import DOMPurify from 'dompurify';
import type { Element, Text } from 'html-react-parser';
import parse from 'html-react-parser';
import type { ComponentType } from 'react';

export type CustomLinkProps = {
  hrefId: string;
  children: string;
};

export const parseSanitize = (
  text?: string | null,
  CustomLink?: ComponentType<CustomLinkProps>,
) =>
  text &&
  parse(
    DOMPurify.sanitize(text, {
      ALLOWED_TAGS: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'div',
        'hr',
        'li',
        'ol',
        'p',
        'ul',
        'b',
        'br',
        'em',
        'i',
        'small',
        'span',
        'strong',
        'u',
        'style',
        'body',
        'table',
        'tr',
        'th',
        'td',
        'customlink',
      ],
      ALLOWED_ATTR: ['target', 'class', 'style', 'start', 'id'],
    }),
    {
      replace: (node) => {
        if ((node as Element).name === 'customlink' && CustomLink) {
          return (
            <CustomLink hrefId={(node as Element)?.attribs?.id || ''}>
              {((node as Element)?.children[0] as Text)?.data}
            </CustomLink>
          );
        }
      },
    },
  );
